import {api} from "@/lib/api/auth/api";
import {IAppLoginCode} from "@/lib/types/auth/IAppLoginCode";

/**
 * Self-service account actions against user-service (AUTH_API) — AC-830.
 *
 * `deleteAccount` soft-deletes the caller's own account: the backend marks the
 * profile DELETED, revokes every refresh token and reports the user as blocked
 * to all services, so the FE must clear local auth right after a 204 (see
 * DeleteAccountForm). Bearer-authed via baseQueryWithRefresh (shared auth `api`).
 */
export const accountApi = api.injectEndpoints({
    endpoints: build => ({
        deleteAccount: build.mutation<void, void>({
            query: () => ({
                url: '/profile/me',
                method: 'delete',
            })
        }),
        /**
         * AC-903: one-time code baked into the APK so the app signs the player in on
         * its first launch. Single-use, 10-minute lifetime — request it right before
         * the download, never cache it.
         */
        issueAppLoginCode: build.mutation<IAppLoginCode, void>({
            query: () => ({
                url: '/profile/app-login-code',
                method: 'post',
            })
        }),
    })
})

export const {useDeleteAccountMutation, useIssueAppLoginCodeMutation} = accountApi;
